// 25 new
const hugCampaign = (function () {
    "use strict";

    const promiseTab = document.querySelectorAll('.ap-tab');
    const promiseEl = document.querySelector('.ap-section--promise');
    const promiseNavWrapper = promiseEl.querySelector('.ap-nav-wrapper');
    const promiseNav = promiseEl.querySelectorAll('.ap-nav-link');
    const promiseConts = promiseEl.querySelectorAll('.ap-section--promise__section');
    const swiperEl = document.querySelectorAll('.ap-swiper');

    // 스크롤 도달시 내비게이션 보임
    const navToggle = () => {
        const firstSectionTop = promiseEl.offsetTop - promiseNavWrapper.clientHeight + 1;
        const lastSectionBottom = promiseEl.offsetTop + promiseEl.clientHeight - promiseNavWrapper.clientHeight + 1;
        const isVisible = window.scrollY >= firstSectionTop && window.scrollY <= lastSectionBottom;

        promiseNavWrapper.style.opacity = isVisible ? "1" : "0";
        promiseNavWrapper.style.pointerEvents = isVisible ? "auto" : "none";
    }
    window.addEventListener(
        "scroll",
        _.throttle(navToggle, 200)
    );

    // 해당 영역으로 스크롤
    const scrollToSection = (event, element, index) => {
        event.preventDefault();

        window.scrollTo({
            top: promiseConts[index].offsetTop - promiseNavWrapper.clientHeight + 1,
            behavior: "smooth",
        });
    }

    // Tab, nav 클릭시 스크롤 함수 호출
    const tabToSection = (elements) => {
        elements.forEach((el, index) => {
            el.addEventListener("click", (e) => scrollToSection(e, el, index));
        });
    }
    tabToSection(promiseNav);
    tabToSection(promiseTab);

    // 탭 활성화
    const promiseTabChange = (index) => {
        promiseNav.forEach(el => {
            el.classList.remove('active');
        });
        promiseNav[index].classList.add('active');
    }
    // 스크롤 영역 도달시 해당 영역의 탭 활성화
    const scrollTabChange = () => {
        const reuseSectionTop = promiseConts[1].offsetTop - promiseNavWrapper.clientHeight;
        const recycleSectionTop = promiseConts[2].offsetTop - promiseNavWrapper.clientHeight;

        if (window.scrollY <= reuseSectionTop) {
            promiseTabChange(0);

        } else if (window.scrollY > reuseSectionTop && window.scrollY <= recycleSectionTop) {
            promiseTabChange(1);

        } else if (window.scrollY > recycleSectionTop) {
            promiseTabChange(2);
        }
    }
    window.addEventListener(
        "scroll", 
        _.throttle(scrollTabChange, 200)
    );

    // swiper
    swiperEl.forEach(el => {
        const pagerEl = el.parentElement.querySelector('.ap-swiper-pager');
        const apSwiper = new Swiper(el, {
            // spaceBetween: 28,
            spaceBetween: 28 * (window.innerWidth / 720),
            slidesPerView: 1.15,
            pagination: {
                el: pagerEl,
                clickable: true
            },
            breakpoints: {
                720:{
                    spaceBetween: 28,
                    slidesPerView: 1,
                    // spaceBetween: 28 * (window.innerWidth / 720),
                    // slidesPerView: 1.15
                }
            }
        })

        const updateSwiper = () => {
            if (window.innerWidth < 720) {
                apSwiper.params.spaceBetween = 28 * (window.innerWidth / 720);
                apSwiper.update();
            }
        }
        window.addEventListener(
            'resize',
            _.throttle(updateSwiper, 200)
        )
    })

})();